module.exports = __webpack_public_path__ + "img/sanitaryWare.c0b62a44.jpg";